import { render, staticRenderFns } from "./FreezingRequests.vue?vue&type=template&id=9ad9596e&"
import script from "./FreezingRequests.vue?vue&type=script&lang=js&"
export * from "./FreezingRequests.vue?vue&type=script&lang=js&"
import style0 from "./FreezingRequests.vue?vue&type=style&index=0&id=9ad9596e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports